import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import styled from 'styled-components'
import {
  TextWidth,
  ContentWidth,
  TextWidthExtended,
} from '@ta-interaktiv/react-disco-grid'
// import ExampleComponent from '../ExampleComponent'
import TableComponent from '../TableComponent'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/table.css'

import { GlobalVariables } from 'Globals/GlobalVariables'

const MainComponent = ({
  tenant,
  colorMode,
  properties,
  trackEvent,
}: MicroFrontendProps) => {
  const Width: any =
    properties?.width === 'TextWidthExtended'
      ? TextWidthExtended
      : properties?.width === 'ContentWidth'
      ? ContentWidth
      : TextWidth
  return (
    <AppContainer $colorMode={colorMode}>
      <Width>
        {/* <ExampleComponent /> */}
        <TableComponent
          colorMode={colorMode}
          tenant={tenant}
          tableTitle={properties?.tableTitle}
          tableColumnHeaders={
            typeof properties?.tableColumnHeaders === 'string'
              ? JSON.parse(properties?.tableColumnHeaders)
              : properties?.tableColumnHeaders
          }
          parties={
            typeof properties?.parties === 'string'
              ? JSON.parse(properties?.parties)
              : properties?.parties
          }
          seatsToday={
            typeof properties?.seatsToday === 'string'
              ? JSON.parse(properties?.seatsToday)
              : properties?.seatsToday
          }
          seatsForecast={
            typeof properties?.seatsForecast === 'string'
              ? JSON.parse(properties?.seatsForecast)
              : properties?.seatsForecast
          }
          seatsChange={
            typeof properties?.seatsChange === 'string'
              ? JSON.parse(properties?.seatsChange)
              : properties?.seatsChange
          }
        />
      </Width>
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)`${GlobalVariables}
  font-family: var(--font-sans-serif);
  font-size: 1.8rem;
  line-height: 3rem;
`
export default MainComponent
